/**
 *
 * @param {Object} objectData
 * @param {number} objectData.numberUserId
 * @param {Object} objectData.objectMetadata
 * @param {string} objectData.objectMetadata.stringOrigin
 * @param {string} objectData.objectMetadata.stringType
 */
import axios from 'axios';

export async function loginAndPageLoad(objectData) {
  try {
    const objectResponse = await axios.post(
      'https://6xh1ym8shh.execute-api.us-west-2.amazonaws.com/prod/pushInternalData',
      {
        messages: [
          {
            queue: 'gs2.analytics',
            message: {
              key: 'general',
              action: 'generate',
              data: {
                user_id: objectData.numberUserId,
                section: 'login',
                sub_section: '',
                name: 'login',
                system: 1,
                metadata: {
                  origin: objectData.objectMetadata.stringOrigin,
                  type: objectData.objectMetadata.stringType,
                },
              },
            },
          },
        ],
      },
    );
  } catch (e) {
    return Promise.reject(e);
  }
}
